import axios from 'axios';

export const axiosInstance = () => {
  return axios.create({
    baseURL: import.meta.env.VITE_BACKEND_PYTHON_URL,
  });
};
